/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'utilities/withRouterWrapper';
import DocumentShow from './DocumentShow';
import PageNotFound from 'common/PageNotFound';
import * as Utilities from 'utilities/utils';

/**
 * Wrapper component for /document?token=... route
 * Extracts token from URL and passes to DocumentShow
 */
class DocumentShowTokenWrapper extends Component {
  render() {
    const { location } = this.props;
    
    // Extract token and source from URL query parameters
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const source = searchParams.get('source');
    
    // If no token provided, show 404
    if (!token) {
      return <PageNotFound />;
    }
    
    // Get user data for passing to DocumentShow
    const homeDataObj = Utilities.getStorageData();
    const years = homeDataObj?.pref_type_options?.upload_file_year || [];
    const months = homeDataObj?.pref_type_options?.upload_file_month || [];
    const tags = homeDataObj?.pref_type_options?.upload_tags || [];
    
    return (
      <DocumentShow
        token={token}
        uploadType={source}
        standalone={true}
        years={years}
        months={months}
        tags={tags}
        {...this.props}
      />
    );
  }
}

export default withRouter(DocumentShowTokenWrapper);

